const React = require('react');
const PropTypes = require('prop-types');
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;

//  @ components
const { ClearAllFiltersButton } = require('commonsComponents/clearAllFiltersButton');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @ helpers
const { countActiveFilters } = require('utilities/filtersHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @ constants
const { DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT, CLEAR_ALL_FILTERS_BUTTON_LABEL } = require('constants/commonsComponents');
const {
    CARD_SITUATION_FILTER_AUTHORIZED,
    CARD_SITUATION_FILTER_LIQUIDATED,
    CARD_SITUATION_FILTER_PENDING_LIQUIDATION,
    CARD_STATE_FILTER_DEFERRED
} = require('constants/index');

class CardLastMovementsContentFilters extends React.Component {
    
    buildTextFilterLabel() {
            const { immTextFilter, resetFilter } = this.props;
            const labeltext = immTextFilter
                .get('selected')
            
            return (
                <LabelFilterRange closeCallback={() => resetFilter('description')} key="filter-description" from={labeltext} />
            );
        }

    buildDateFilterLabel() {
        const { immDateFilter, resetFilter } = this.props;
        const labelFromDate = immDateFilter
            .get('from')
            .locale(DATE_PICKER_CUSTOM_LOCALE)
            .format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));    
        const labelToDate = immDateFilter
            .get('to')
            .locale(DATE_PICKER_CUSTOM_LOCALE)
            .format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));

        return (
            <LabelFilterRange closeCallback={() => resetFilter('date')} key="filter-date" from={labelFromDate} to={labelToDate} />
        );
    }
   
    buildAmountFilterLabel() {
        const { immAmountFilter, resetFilter } = this.props;
        const plainAmountFromObject = getPlainAmountObject(immAmountFilter.get('from'));
        const plainAmountToObject = getPlainAmountObject(immAmountFilter.get('to'));
        const language = getLanguage();
        let fromElem = null, toElem = null;

        if (immAmountFilter.get('from').get('amount') !== null) {
            fromElem = (
                <span>
                    <FormattedText value="filters-min" />
                    <OneLineSymbolAmount
                        amountObject={plainAmountFromObject}
                        className="account-last-movements-content-filters__right-side-value"
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountFromObject, true)} />
                </span>
            );
        }

        if (immAmountFilter.get('to').get('amount') !== null) {
            toElem = (
                <span>
                    <FormattedText value="filters-max" />
                    <OneLineSymbolAmount
                        amountObject={plainAmountToObject}
                        className="account-last-movements-content-filters__right-side-value"
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountToObject, true)} />
                </span>
            );
        }

        return (
            <LabelFilterRange
                key="filter-amount"
                from={fromElem}
                to={toElem}
                closeCallback={() => resetFilter('amount')}
            />
        );
    }
    buildStateFilterLabel() {
        const { immStateFilter, resetFilter } = this.props;
        const stateLabel = immStateFilter.get('selected') === CARD_STATE_FILTER_DEFERRED ?
            formatText('filterCardState-deferred') :
            formatText('filterCardState-notDeferred');

        return (
            <LabelFilterRange
                closeCallback={() => resetFilter('state')}
                from={stateLabel}
                key="filter-state"
            />
        );
    }

    buildSituationFilterLabel() {
        const { immSituationFilter, resetFilter } = this.props;
        const labels = {
            [CARD_SITUATION_FILTER_LIQUIDATED]: formatText('filterCardSituation-liquidated'),
            [CARD_SITUATION_FILTER_PENDING_LIQUIDATION]: formatText('filterCardSituation-pendingLiquidation'),
            [CARD_SITUATION_FILTER_AUTHORIZED]: formatText('filterCardSituation-authorized')
        };
        const situationLabel = labels[immSituationFilter.get('selected')];

        return (
            <LabelFilterRange closeCallback={() => resetFilter('situation')} key="filter-situation" from={situationLabel} />
        );
    }

    createButtonClearAllFilters() {
        const { immFilters, clearFilters } = this.props;
        let response;

        if (countActiveFilters(immFilters) > 1) {
            response = <ClearAllFiltersButton label={CLEAR_ALL_FILTERS_BUTTON_LABEL} onClick={clearFilters} />;
        }

        return response;
    }

    render() {
        const {
            immDateFilter,
            immSituationFilter,
            immStateFilter,
            immTextFilter,
            immTransactions,
            showStateFilter,
            immAmountFilter
        } = this.props;
        let content;

        if (immTransactions) {
            const dateFilterActiveContent = immDateFilter.get('isActive') ?
                this.buildDateFilterLabel() :
                '';
            const stateFilterActiveContent = immStateFilter.get('isActive') && showStateFilter ?
                this.buildStateFilterLabel() :
                '';
                const textFilterActiveContent = immTextFilter.get('isActive')  ?
                this.buildTextFilterLabel() :
                '';
            const situationFilterActiveContent = immSituationFilter.get('isActive') ?
                this.buildSituationFilterLabel() :
                '';
            const amountFilterActiveContent = immAmountFilter.get('isActive') ?
                this.buildAmountFilterLabel() :
                '';
            const clearAllFiltersButton = this.createButtonClearAllFilters();

            content = (
                <div className="card-last-movements-content-filters__applied-filters" >
                    {textFilterActiveContent}
                    {dateFilterActiveContent}
                    {situationFilterActiveContent}
                    {stateFilterActiveContent}
                    {amountFilterActiveContent}
                    {clearAllFiltersButton}
                </div>
            );
        }

        return content;
    }
}

CardLastMovementsContentFilters.defaultProps = {
    showStateFilter: true,
}

CardLastMovementsContentFilters.propTypes = {
    clearFilters: PropTypes.func.isRequired,
    immDateFilter: PropTypes.object.isRequired,
    immFilters: PropTypes.object,
    immAmountFilter:PropTypes.object,
    immSituationFilter: PropTypes.object.isRequired,
    immStateFilter: PropTypes.object.isRequired,
    immTextFilter: PropTypes.object.isRequired,
    immTransactions: PropTypes.object,
    resetFilter: PropTypes.func.isRequired,
    showStateFilter: PropTypes.bool,

}

module.exports = CardLastMovementsContentFilters;
